import 'regenerator-runtime/runtime';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { navigate } from '@reach/router';
// biw
import { Bridge } from '@nackle/bridge';
import { setOptions } from '@nackle/salesmaker-client-fetch';
// auth
import auth from './auth';
// main app
import App from 'components/app';
import createAppStore from './store';
// styles
import './app.less';

const AppStore = createAppStore();

class BridgeAndProvider extends React.Component {
    constructor( props ) {
        super( props );
    }
    state = {
        user: false
    };
    setOptions = async user => {
        const match = window.location.pathname.match(
            /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
        );
        const companyId = match && match[ 0 ];
        if ( companyId ) {
            await auth.delegate( companyId );
        } else {
            await setOptions( {
                headers: {
                    Authorization: `Bearer ${ user.access_token }`,
                    'company-id': user.claims.company_id,
                    'person-id': user.claims.person_id,
                    'x-company-id': user.claims.companyId,
                    'x-person-id': user.claims.personId
                }
            } );
            await this.setState( { user } );
            navigate( `/${ user.claims.company_id }` );
        }
    };

    resetOptions = async () => {
        const authState = auth.state;
        if ( !authState.delegate.access_token ) {
            return;
        }
        await setOptions( {
            headers: {
                Authorization: `Bearer ${ authState.delegate.access_token ||
                    authState.access_token }`,
                'company-id': authState.delegate.claims.company_id,
                'person-id': authState.delegate.claims.person_id
            }
        } );
        await this.setState( { user: authState } );
        if ( !window.location.pathname.includes( 'version' ) ) {
            const match = window.location.pathname.match(
                /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
            );
            navigate(
                `/${ ( match && match[ 0 ] ) ||
                    authState.delegate.claims.company_id ||
                    authState.claims.company_id }`
            );
        }
    };
    render() {
        const hasUser = !!this.state.user;
        return (
            <Bridge auth={ auth } onSignIn={ this.setOptions } onAuthStateChange={ this.resetOptions }>
                { hasUser && (
                    <Provider store={ AppStore }>
                        <App user={ this.state.user } />
                    </Provider>
                ) }
            </Bridge>
        );
    }
}

ReactDOM.render( <BridgeAndProvider />, document.getElementById( 'app' ) );
